function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#ffe600;}.cls-3{opacity:0.75;mix-blend-mode:multiply;}.cls-4{fill:#1d1d1b;}"));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  className: "cls-1"
}, /*#__PURE__*/React.createElement("g", {
  id: "Capa_2",
  "data-name": "Capa 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Capa_1-2",
  "data-name": "Capa 1"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "52.53 0 482.67 0.09 449.63 59.03 473.69 59.08 415.28 144.33 3.09 140.41 52.53 0"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-4",
  points: "25.4 4.15 66.83 4.23 34.07 63.17 57.92 63.22 0 148.48 23.99 79.47 0.14 79.43 25.4 4.15"
})), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "25.4 0 66.83 0.08 34.07 59.02 57.92 59.07 0 144.33 23.99 75.32 0.14 75.28 25.4 0"
}))));
function SvgBgTitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 482.67 148.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _ref2, title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icono_rayobloque") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgTitle);
export default __webpack_public_path__ + "static/media/bg-title.10a095769b8c466d9f98e121b0b7d0bd.svg";
export { ForwardRef as ReactComponent };